<template>
  <div id="device-groups" class="flex flex-col flex-grow">
    <!-- Header action buttons -->
    <div class="header-action-buttons flex">
      <base-button-icon
        @click="fetchDeviceGroups"
        :loading="pendingRequest"
        size="sm"
        icon="refresh"
        class="text-primary"
      >
      </base-button-icon>
      <base-button
        class="ml-auto"
        action="create_device_group"
        size="sm"
        @click="onDeviceGroupCreate"
      >
        <base-icon icon="plus" class="text-lg" />
      </base-button>
    </div>

    <hr class="my-5" />

    <!-- Main section -->
    <div class="main-section flex relative">
      <!-- Listing -->
      <div class="device-groups-listing w-128 mr-6 h-128 sticky top-16">
        <DeviceGroupsFilters />
        <DeviceGroupsListing
          :groups="filteredData"
          :pagination-data="paginationData"
          :loading="pendingRequest"
          @loadMore="fetchDeviceGroups(false)"
        />
      </div>

      <!-- Details -->
      <div class="w-full">
        <!-- No group selected -->
        <div v-if="!editedGroupMode" class="flex flex-col items-center justify-start w-full h-full">
          <div class="flex flex-col relative items-center w-full mt-8">
            <div class="bg-blue-default opacity-25 rounded pin-t w-80 h-48"></div>
            <div
              class="absolute pin-t z-20 bg-white w-80 mt-8 h-32 -ml-4 lg:-ml-24 shadow-md rounded flex items-center justify-center"
            >
              <BaseIcon
                class="text-5xl text-blue-default px-8 py-4 flex items-center"
                icon="group"
              />
            </div>
            <div class="mt-8 text-center">
              <h2>{{ $t(`mygwf.components.User.GroupsBanner.title`) }}</h2>
              <p class="mt-4 text-secondary-dark">
                {{ $t(`mygwf.components.User.GroupsBanner.subtitle`) }}
              </p>
            </div>
          </div>
        </div>
        <!-- Group details -->
        <DeviceGroupsEdit v-else @close="$router.push({name: 'DeviceGroups'})" />
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import DeviceGroupsEdit from './DeviceGroupsEdit.vue'
import DeviceGroupsListing from './DeviceGroupsListing.vue'
import DeviceGroupsFilters from './DeviceGroupsFilters.vue'
import {BaseButtonIcon, BaseIcon, BaseButton, BaseCard} from '@/components/base'

export default {
  components: {
    BaseIcon,
    BaseButton,
    BaseButtonIcon,
    BaseCard,
    DeviceGroupsEdit,
    DeviceGroupsListing,
    DeviceGroupsFilters,
  },

  data() {
    return {
      pendingComponentInit: false,
      pendingRequest: false,
    }
  },

  computed: {
    ...mapGetters('deviceGroups', ['deviceGroups', 'paginationData', 'editedGroupMode']),
    filteredData() {
      let groupsArray = this.deviceGroups

      let nameFilter = this.$route.query.name || ''
      const nameMatcher = new RegExp(nameFilter.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i')

      let companyFilter = Array.from(this.$route.query.company || []).map(v => parseInt(v, 10))

      return groupsArray
        .filter(value => nameMatcher.test(value.name))
        .filter(value => (companyFilter.length > 0 ? companyFilter.includes(value.company) : true))
    },
  },

  created() {
    this._initComponent()
  },

  methods: {

    onDeviceGroupCreate() {
      this.$store.dispatch('deviceGroups/clearEditedGroup')
      this.$router.push({name: 'DeviceGroups'})
      this.$store.dispatch('deviceGroups/setEditedGroup', {mode: 'creation'})
    },

    async fetchDeviceGroups(refresh = true) {
      if (this.pendingRequest) {
        return
      }
      this.pendingRequest = true
      try {
        await this.$store.dispatch('deviceGroups/getDeviceGroups', refresh)
        return Promise.resolve()
      } catch (e) {
        return Promise.reject(e)
      } finally {
        setTimeout(() => (this.pendingRequest = false), 0)
      }
    },

    async _initComponent() {
      if (this.pendingComponentInit) {
        return
      }
      this.pendingComponentInit = true
      try {
        await this.fetchDeviceGroups()
        if (this.$route.params.uuid) {
          await this.$store.dispatch('deviceGroups/setEditedGroup', {
            uuid: this.$route.params.uuid,
            mode: 'edit',
          })
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.pendingComponentInit = false
      }
    },
  },
}
</script>
